import { FC } from 'react';
import Form from '../../../../components/common/Forms/Form';
import { EmploymentInformationFields, normalizeInitialValues } from '../../../../config/tuitionMangerViewDetailsFields';

interface EmploymentInformationProps {
  applicationData?: any;
}

const EmploymentInformation: FC<EmploymentInformationProps> = ({ applicationData }) => {
  return (
    <div>
      <h2 className="h3">Employment information</h2>
      <Form
        fields={EmploymentInformationFields}
        initialValues={normalizeInitialValues(applicationData, EmploymentInformationFields)}
        isViewDetails
        buttons={[]}
        className="mt-4"
      />
    </div>
  );
};

export default EmploymentInformation;
